import { createContext, useState } from 'react'

export const FilterContext = createContext({})

export const FilterProvider = ({ children }) => {
  const [filtroExameSetores, setFiltroExameSetores] = useState([])
  const [filtroExameTipos, setFiltroExameTipos] = useState([])
  const [filtroExameStatus, setFiltroExameStatus] = useState([])
  const [filtroExameUsuarioRequisitante, setFiltroExameUsuarioRequisitante] = useState([])
  const [filtroExameDataSolicitacaoInicio, setFiltroExameDataSolicitacaoInicio] = useState(null)
  const [filtroExameDataSolicitacaoFinal, setFiltroExameDataSolicitacaoFinal] = useState(null)
  const [filtroExameDataSolicitacaoChecked, setFiltroExameDataSolicitacaoChecked] = useState(false)
  const [filtroExameDataCriacaoInicio, setFiltroExameDataCriacaoInicio] = useState(null)
  const [filtroExameDataCriacaoFinal, setFiltroExameDataCriacaoFinal] = useState(null)
  const [filtroExameDataCriacaoChecked, setFiltroExameDataCriacaoChecked] = useState(false)

  const [filtroExameDataAtribuicaoInicio, setFiltroExameDataAtribuicaoInicio] = useState(null)
  const [filtroExameDataAtribuicaoFinal, setFiltroExameDataAtribuicaoFinal] = useState(null)
  const [filtroExameDataAtribuicaoChecked, setFiltroExameDataAtribuicaoChecked] = useState(false)

  const [filtroExameDataFinalizacaoInicio, setFiltroExameDataFinalizacaoInicio] = useState(null)
  const [filtroExameDataFinalizacaoFinal, setFiltroExameDataFinalizacaoFinal] = useState(null)
  const [filtroExameDataFinalizacaoChecked, setFiltroExameDataFinalizacaoChecked] = useState(false)

  const [filtroExameExaminadores, setFiltroExameExaminadores] = useState([])
  const [filtroExameNumeroProcedimento, setFiltroExameNumeroProcedimento] = useState(null)
  const [filtroExameNumeroDocumento, setFiltroExameNumeroDocumento] = useState(null)

  const [filtroExameDataPublicacaoInicio, setFiltroExameDataPublicacaoInicio] = useState(null)
  const [filtroExameDataPublicacaoFinal, setFiltroExameDataPublicacaoFinal] = useState(null)
  const [filtroExameDataPublicacaoChecked, setFiltroExameDataPublicacaoChecked] = useState(false)

  return (
    <FilterContext.Provider
      value={{
        filtroExameSetores,
        setFiltroExameSetores,
        filtroExameTipos,
        setFiltroExameTipos,
        filtroExameStatus,
        setFiltroExameStatus,
        filtroExameUsuarioRequisitante,
        setFiltroExameUsuarioRequisitante,
        filtroExameDataSolicitacaoInicio,
        setFiltroExameDataSolicitacaoInicio,
        filtroExameDataSolicitacaoFinal,
        setFiltroExameDataSolicitacaoFinal,
        filtroExameDataSolicitacaoChecked,
        setFiltroExameDataSolicitacaoChecked,
        filtroExameDataCriacaoInicio,
        setFiltroExameDataCriacaoInicio,
        filtroExameDataCriacaoFinal,
        setFiltroExameDataCriacaoFinal,
        filtroExameDataCriacaoChecked,
        setFiltroExameDataCriacaoChecked,
        filtroExameDataAtribuicaoInicio,
        setFiltroExameDataAtribuicaoInicio,
        filtroExameDataAtribuicaoFinal,
        setFiltroExameDataAtribuicaoFinal,
        filtroExameDataAtribuicaoChecked,
        setFiltroExameDataAtribuicaoChecked,
        filtroExameDataFinalizacaoInicio,
        setFiltroExameDataFinalizacaoInicio,
        filtroExameDataFinalizacaoFinal,
        setFiltroExameDataFinalizacaoFinal,
        filtroExameDataFinalizacaoChecked,
        setFiltroExameDataFinalizacaoChecked,
        filtroExameExaminadores,
        setFiltroExameExaminadores,
        filtroExameNumeroProcedimento,
        setFiltroExameNumeroProcedimento,
        filtroExameNumeroDocumento,
        setFiltroExameNumeroDocumento,
        filtroExameDataPublicacaoInicio,
        setFiltroExameDataPublicacaoInicio,
        filtroExameDataPublicacaoFinal,
        setFiltroExameDataPublicacaoFinal,
        filtroExameDataPublicacaoChecked,
        setFiltroExameDataPublicacaoChecked,
      }}
    >
      {children}
    </FilterContext.Provider>
  )
}
